// extracted by mini-css-extract-plugin
module.exports = {"SortFilter":"SortFilter_SortFilter__3E6Wx","Icon":"SortFilter_Icon__2Dd0N"};